<template lang="pug">
  el-dialog(title="查看详情", :close-on-click-modal='false',:visible.sync='visible' :modal-append-to-body='false')
    el-form(:model='dataForm', :rules='dataRule', ref='dataForm',label-suffix=":"  label-width='100px')
      el-form-item(label='姓名', prop='name')
        <span>{{dataForm.name}}</span>
      el-form-item(label='手机号码', prop='tel')
        <span>{{dataForm.tel}}</span>
      el-form-item(label='身份证号')
        <span>{{dataForm.code}}</span>
      el-form-item(label='主办方', prop='orgName')
        <span>{{dataForm.orgName}}</span>
      el-form-item(label='地区')
        <span>{{addressName}}</span>
      el-form-item(label='级别', prop='level')
        <span>{{dataForm.level}}</span>
      el-form-item(label='性别')
        <span>{{dataForm.gender}}</span>
      el-form-item(label='职业', prop='position')
        <span>{{dataForm.position}}</span>
      el-form-item(label='邮箱', prop='email')
        <span>{{dataForm.email}}</span>
      el-form-item(label='银行卡号', prop='bankid')
        <span>{{dataForm.bankid}}</span>
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 返回
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        name:'',
        tel:'',
        code:'',
        orgId:'',
        proviceId: '',
        cityId: '',
        level: null,
        gender:null,
        position: null,
        email: '',
        bankid: '',
        proviceName: '',
        cityNames: '',
        orgName: ''
      }
    }
  },
    computed: {
        addressName: function() {
            if(this.dataForm.proviceName==this.dataForm.cityNames){
                return this.dataForm.proviceName
            }else{
                return this.dataForm.proviceName + '' + this.dataForm.cityNames
            }
        }
    },
  methods: {
    init1 (id) {
      this.dataForm.id = id || 0
      this.visible = true
          this.$http({
            url: this.$http.adornUrl(`/ctReferee/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
                    this.dataForm.name = data.bean.name
                    this.dataForm.tel = data.bean.tel
                    this.dataForm.code = data.bean.code
                    this.dataForm.orgId = data.bean.orgId
                    this.dataForm.email = data.bean.email
                    this.dataForm.bankid = data.bean.bankid
                    if(data.bean.gender==0){
                      this.dataForm.gender = '男'
                    }else if(data.bean.gender==1){
                      this.dataForm.gender = '女'
                    }
                    this.dataForm.level = data.bean.level
                    if(data.bean.position==1){
                      this.dataForm.position = '学生'
                    }else if(data.bean.position==2){
                      this.dataForm.position = '在职'
                    }
                    this.dataForm.orgName = data.bean.orgName
                    this.dataForm.proviceName = data.bean.proviceName
                    this.dataForm.cityNames = data.bean.cityNames
          }
        })
      }
   }
 }
</script>
